<template>
  <div>
    <search-area tabName="提现审核列表" @search="search(1)">
      <Form
        ref="searchParam"
        :model="searchParam"
        :label-width="55"
        inline
        label-position="right"
        label-colon
      >
        <!-- <FormItem label="交易状态" prop="transactionStatus" :label-width="105">
          <Select
            v-model="searchParam.transactionStatus"
            style="width: 160px"
            @on-change="search(1)"
            clearable
          >
            <Option
              v-for="item in statusList"
              :value="item.code"
              :key="item.code"
              >{{ item.value }}</Option
            >
          </Select>
        </FormItem> -->
      </Form>
    </search-area>
    <table-area
      :columns="columns"
      :data="withdrawList"
      :total="total"
      @search="search"
      :pageNum="searchParam.page"
      :pageSize="searchParam.pageSize"
    ></table-area>

    <!-- 拒绝理由弹窗 -->
    <Modal
      v-model="showRejectDialog"
      title="拒绝提现申请"
      @on-ok="confirmReject"
      @on-cancel="cancelReject"
    >
      <Form :model="rejectForm" :label-width="80">
        <FormItem label="拒绝理由" prop="remark">
          <Input
            v-model="rejectForm.remark"
            type="textarea"
            :rows="4"
            placeholder="请输入拒绝理由"
            :maxlength="200"
            show-word-limit
          ></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
import columns from "./withdraw-column";
export default {
  data() {
    return {
      columns: columns(this),
      // 列表数据总数
      total: 0,
      // 加载中
      loading: false,
      // 搜索参数
      searchParam: {
        transactionType: 4,
        transactionStatus: "", // 交易状态
        transactionType: "", // 交易类型：2表示提现
        page: 1,
        pageSize: 10,
      },
      withdrawList: [],
      statusList: [
        { code: 0, value: "提交申请" },
        { code: 1, value: "处理中(同意)" },
        { code: 2, value: "成功" },
        { code: 3, value: "失败（拒绝）" },
      ],
      showRejectDialog: false,
      currentRow: null, // 当前要拒绝的行数据
      rejectForm: {
        remark: "",
      },
    };
  },
  created() {
    this.getWithdrawList();
  },
  methods: {
    // 执行搜索
    search(val) {
      this.searchParam.page = val;
      this.getWithdrawList();
    },
    async getWithdrawList() {
      // 过滤掉空值参数
      const params = {};
      Object.keys(this.searchParam).forEach((key) => {
        if (
          this.searchParam[key] !== "" &&
          this.searchParam[key] !== null &&
          this.searchParam[key] !== undefined
        ) {
          params[key] = this.searchParam[key];
        }
      });
      params.transactionType = '4'
      try {
        let res = await this.$post("/wallet/transactions", params);
        console.log(res);
        // 根据实际返回的数据结构调整
        if (res && res.list) {
          this.withdrawList = res.list || [];
          this.total = res.total || 0;
        } else if (Array.isArray(res)) {
          this.withdrawList = res || [];
          this.total = res.length || 0;
        } else {
          this.withdrawList = [];
          this.total = 0;
        }
      } catch (error) {
        console.error("获取提现列表失败:", error);
        this.withdrawList = [];
        this.total = 0;
      }
    },
    // 审核提现
    async handleReview(row, transactionStatus) {
      // 如果是拒绝，需要填写拒绝理由
      if (transactionStatus === 3) {
        this.currentRow = row;
        this.rejectForm.remark = "";
        this.showRejectDialog = true;
      } else {
        // 同意审核
        this.$Modal.confirm({
          title: "确认审核",
          content: `确定要同意该提现申请吗？`,
          onOk: async () => {
            await this.submitReview(row, transactionStatus, "");
          },
        });
      }
    },
    // 确认拒绝
    async confirmReject() {
      if (!this.rejectForm.remark || this.rejectForm.remark.trim() === "") {
        this.$Message.warning("请输入拒绝理由");
        return;
      }
      await this.submitReview(
        this.currentRow,
        3,
        this.rejectForm.remark.trim()
      );
      this.showRejectDialog = false;
      this.rejectForm.remark = "";
      this.currentRow = null;
    },
    // 取消拒绝
    cancelReject() {
      this.showRejectDialog = false;
      this.rejectForm.remark = "";
      this.currentRow = null;
    },
    // 提交审核
    async submitReview(row, transactionStatus, remark) {
      try {
        const params = {
          id: row.id,
          transactionStatus: transactionStatus,
        };
        // 如果是拒绝，添加拒绝理由
        if (transactionStatus === 3 && remark) {
          params.remark = remark;
        }

        const res = await this.$post("/wallet/reviewWithdraw", params);

        if (res) {
          const statusText = transactionStatus === 3 ? "拒绝" : "同意";
          this.$Message.success(`${statusText}成功`);
          this.getWithdrawList();
        } else {
          const statusText = transactionStatus === 3 ? "拒绝" : "同意";
          this.$Message.error(`${statusText}失败`);
        }
      } catch (error) {
        console.error("审核失败:", error);
        const statusText = transactionStatus === 3 ? "拒绝" : "同意";
        this.$Message.error(`${statusText}失败`);
      }
    },
  },
  components: {},
};
</script>

<style lang="stylus" scoped>
@import './../../styl/variables.styl'
@import './../../styl/common.styl'
</style>
